import { BaseSyntheticEvent } from 'react';
import { Modal, Message, Form } from 'semantic-ui-react';
import { Icon } from '@britishcouncil/react-admin';
import {
  DebouncedLoader,
  ErrorsContextProvider,
  ReadonlyField,
  RHFormNumberInput,
  RHFormSelect,
  ValidationErrors,
} from 'components';
import { Footer } from './Footer';
import { useLinkNewSpeakingSession } from './useLinkNewSpeakingSession';

type Props = {
  hasAvailableSessions: boolean;
};

export const LinkNewSpeakingSession = ({ hasAvailableSessions }: Props) => {
  const {
    lrwSession,
    form,
    venueOptions,
    isFetchingVenues,
    createdAndLinked,
    isCreatingAndLinking,
    generalErrors,
    handleSubmit,
  } = useLinkNewSpeakingSession();

  return (
    <ErrorsContextProvider generalErrors={generalErrors}>
      <Modal
        open
        as={Form}
        onSubmit={(e: BaseSyntheticEvent) => {
          form.handleSubmit(handleSubmit)(e);
        }}
      >
        <Modal.Header>Create and link Speaking session</Modal.Header>
        <DebouncedLoader isFetching={!lrwSession} />
        <Modal.Content>
          {!hasAvailableSessions && (
            <Message
              icon="info circle"
              color="blue"
              content="There's no existing Speaking sessions that could be linked. Please create a new Speaking session."
            />
          )}
          <ValidationErrors />
          <ReadonlyField header="Date">
            <Icon name="calendar alternate outline" />
            {lrwSession?.date}
          </ReadonlyField>
          <RHFormSelect
            name="venueId"
            control={form.control}
            label="Venue"
            options={venueOptions}
            disabled={isFetchingVenues}
            loading={isFetchingVenues}
          />
          <RHFormNumberInput
            label="Test taker admission time"
            name="testTakerAdmissionTimeMinutes"
            control={form.control}
            min={0}
            max={99}
            innerLabel={{ basic: true, content: 'min' }}
            innerLabelPosition="right"
            width="3"
          />
        </Modal.Content>
        <Footer
          submitText="Create and link"
          isSubmitting={isCreatingAndLinking}
          submitted={createdAndLinked}
        />
      </Modal>
    </ErrorsContextProvider>
  );
};
